import styles from './BlocREDLWrapper.module.scss';
import Structure from 'components/REDL/Structure';
import { useEffect, useRef } from 'react';
import { monitorForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import { autoScrollWindowForElements } from '@atlaskit/pragmatic-drag-and-drop-auto-scroll/element';
import { canMove } from '../utils/dragAndDrop';
import { useRedlMetadata } from 'hooks/useRedlMetadata';
import { useRouter } from 'next/router';
import BottomBar from '../Components/BottomBar/BottomBarComponent';
import OffCanvasLayout from '../Components/OffCanvasLayout/OffCanvasLayoutComponent';
import RightSidePanel from '../Components/RightSidePanel';
import AfegirBlocComponent from '../Components/AfegirBloc';
import EditarBlocComponent from '../Components/EditarBloc';
import PortalComponent from '../Components/Portal';
import Toast from '../Components/Toast/ToastComponent';
import { useRedl } from 'hooks/useRedl';
import __debounce from 'lodash/debounce';
import Divider from '../Components/Divider/DividerComponent';

export default function BlocREDLWrapper(props) {
    const { showRightSidePanel, setShowRightSidePanel, zoom, hidePreview, setScrollPercentage } = useRedl();
    const router = useRouter();
    const { moveRedlBloc } = useRedlMetadata(router.pathname);
    const ref = useRef(null);

    const delayedSetScroll = __debounce(() => {
        if (ref.current) {
            const boundingClientRect = ref.current.getBoundingClientRect();
            setScrollPercentage(Math.min(Math.max(0, -boundingClientRect.top / boundingClientRect.height), 1));
        }
    }, 150);

    useEffect(() => {
        return autoScrollWindowForElements({
            canScroll: ({ source }) => source.data.type === 'block',
            getConfiguration: () => ({
                maxScrollSpeed: 'fast'
            })
        });
    });

    useEffect(delayedSetScroll, [delayedSetScroll, hidePreview, zoom]);

    useEffect(() => {
        document.addEventListener('scroll', delayedSetScroll);
        return () => {
            document.removeEventListener('scroll', delayedSetScroll);
        };
    }, [ref, delayedSetScroll]);

    useEffect(() => {
        return monitorForElements({
            onDrop({ source, location }) {
                const destination = location.current.dropTargets[0];
                if (!destination) {
                    // if dropped outside of any drop targets
                    return;
                }
                if (!canMove(source, destination.data.blocIdx)) {
                    return;
                }
                moveRedlBloc(source.data.blocIdx, destination.data.blocIdx - (destination.data.blocIdx < source.data.blocIdx ? 1 : 2));
            }
        });
    }, [moveRedlBloc]);

    return (
        <>
            {hidePreview ? <Structure {...props} /> :
                <div className={styles.blocREDLWrapper} ref={ref} data-testid="REDL-wrapper">
                    <div className={styles.blocREDLContent} style={{ zoom: `${zoom}%` }}>
                        <Structure {...props} />
                        <Divider blocIdx={props.structure?.length + 1} size="lg" />
                    </div>
                    <OffCanvasLayout ultimBloc={props.structure.length} />
                </div>}
            <PortalComponent>
                <BottomBar />
            </PortalComponent>
            <RightSidePanel visible={showRightSidePanel?.size} closePanel={() => setShowRightSidePanel(null)}>
                {showRightSidePanel?.action === 'add' || showRightSidePanel?.action === 'addDefault' ?
                    <AfegirBlocComponent /> : ['edit'].includes(showRightSidePanel?.action) ?
                        <EditarBlocComponent /> : null}
            </RightSidePanel>
            <Toast />
        </>
    );
}